export function isIe() {
	if (typeof window !== 'undefined' && !!window.document) {
		return navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;
	}

	return false;
}
